import i18n from 'i18next';
import { useEffect, useState } from 'react';
import useShipmentAppointmentList from '../../../redux/hooks/useShipmentAppointmentList';
import FormSelectBox from '../Inputs/FormSelectBox';

const AppointmentSelector = ({
  placeholder = i18n.t('translation:default.fields.appointmentType.placeholder'),
  label = i18n.t('translation:default.fields.appointmentType.label'),
  rules = [],
  name,
  editMode,
  margin = 'mb-0',
  onChange = false,
}) => {
  const [options, setOptions] = useState([]);
  const countryList = useShipmentAppointmentList();

  useEffect(() => {
    if (countryList?.length >= 0) {
      const options = countryList.map((row) => ({
        label: row.text,
        value: row.value,
      }));
      setOptions(options);
    } else {
      setOptions([]);
    }
  }, [countryList]);

  return (
    <FormSelectBox
      loading={countryList === undefined}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
    />
  );
};

export default AppointmentSelector;
